<h1 style="padding-top: 2rem;">Step 3: Get Out of Bed If You’re Not Sleeping</h1>
<div class="row">
    <div class="col-md-6" style="font-family: Karla; font-size : 14px;">
        <p>
            Augmenting step 2, if you are trying to fall asleep or if you wake up in the middle of the night and you're
            not
            able to fall back asleep after 20-30 minutes, you should get out of bed to do something else that is
            soothing
            for a while until you feel sleepy. Then you can go back to the bedroom and try to fall asleep again.
        </p><br>

        <p>
            It is important that you do not constantly look at the clock to see how long you have been awake. If it
            feels
            like it has been a half hour or so and you are not feeling sleepy, then it is time to get out of bed. Doing
            so
            will help to train your brain to condition or correlate that bed is for sleeping, and the rest of the house
            is
            for being awake.
        </p><br>

        <p>
            This step, like the others, can also help to keep you from being too frustrated in bed. As mentioned before,
            frustration can be one of your worst enemies for getting a good night's sleep.
        </p><br>

    </div>
    <div class="col-md-6">
        <div class="row justify-content-around">
            <img src="/assets/actionplan-step3-1.png" style="width: 70%;" />
            <q style="width: 90%;">
                Train your brain to condition of correlate that bed is for sleeping
            </q>
        </div>
    </div>
</div>
<style>
    q::before {
        color: #055D9D;
        display: block;
        content: open-quote;
        font-size: 2rem;
    }

    q {
        quotes: '\201c''\201d';
        font-size: 20px;
        font-family: 'Karla';
        font-weight: bold;
        line-height: 32px;
        padding-left: 2rem
    }

    q::after {
        color: #055D9D;
        display: block;
        content: close-quote;
        font-size: 2rem;
    }
</style>